export default __webpack_public_path__ + "static/media/happybells.72d5668f.mp3";